import { IMultiFilter } from '../../shared/types/interfaces';
import { ConfiguredControl } from '../../types/internal-interfaces';

class State {
  filter: IMultiFilter;
  selectedOptions?: object;
  selectedOptionsCount?: number;
  control?: ConfiguredControl;
}

export class SearchFilterState {
  public states: State[] = [];

  public get hasFilters() {
    return this.states?.length > 0;
  }

  constructor() {}

  public load(filters: IMultiFilter[]): void {
    this.states = [];

    filters.forEach((f: IMultiFilter) => {
      if (!f.id) {
        throw `Empty id found - headingText: ${f.headingText} - type: ${f.type}`;
      }

      if (this.states.findIndex((s: State) => s.filter.id == f.id) > -1) {
        throw 'Duplicate id found - ' + f.id;
      }

      this.states.push({
        filter: f,
      });
    });
  }

  public loadFromResults(results: object): void {
    this.states.forEach((state: State) => {
      const controlValue = results[state.filter.id];
      state.selectedOptions = controlValue;
      state.control.filterControl.setValue(controlValue);
    });
  }

  public setSelectedOptionsCount(id: string, count: number): void {
    this.findState(id).selectedOptionsCount = count;
  }

  public setResult(id: string, options: object) {
    this.findState(id).selectedOptions = options;
  }

  public getResults(): object {
    const results: object = {};

    this.states.forEach((s: State) => {
      results[s.filter.id] = s.selectedOptions;
    });

    return results;
  }

  public getControl(id: string): ConfiguredControl {
    return this.findState(id).control;
  }

  public registerControl(id: string, control: ConfiguredControl): void {
    this.findState(id).control = control;
  }

  private findState(id: string): State {
    return this.states.find((s: State) => s.filter.id == id);
  }
}
